import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleEditMode } from 'actions/editor';

import _ from 'lodash';
import cx from 'classnames';
import { Frame } from 'scenejs';

import { EditorContext } from '../../../index';

import { Property } from '../../../components/properties/';
import { ButtonWidgetMobileAction, ButtonStyleEditor, ButtonTextEditor } from '../../button';
import styles from '../../button/button.module.scss';

const PaginationButtonWidget = {};

const PaginationButtonWidgetDesktopAction = (props) => {
  const dispatch = useDispatch();

  const [view, setView] = useState(null);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const id = _.get(props, 'uid');
  const editMode = useSelector(state => {
    return _.get(state, `${editorSession}.present.editMode`) === id
  });

  const handleEditMode = () => {
    dispatch(toggleEditMode(editorSession, props.uid, true));
    setView(null);
  }

  const changeView = (view) => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(view);
  }

  const closePopup = () => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(null);
  }

  return (
    <>
      <Property.Action className={styles.textButton} onClick={handleEditMode.bind(this, 'text')}>Change Text</Property.Action>
      <Property.Divider />
      <Property.Action className={styles.iconButton} tooltip='Style' onClick={() => changeView('style')}>
        <i className={cx("cleverstory-customize")} />
      </Property.Action>

      {editMode &&
        <ButtonTextEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {!editMode && view === 'style' &&
        <ButtonStyleEditor
          editor={editorSession}
          widgets={[props]}
          onCancel={() => {
            closePopup()
          }}
        />
      }
    </>
  );
}

PaginationButtonWidget.actions = (editor, breakpoint, props) => {
  return (
    <>
      {breakpoint === 'desktop' &&
        <PaginationButtonWidgetDesktopAction editorSession={editor} breakpoint={breakpoint} {...props} />
      }

      {breakpoint === 'mobile' &&
        <ButtonWidgetMobileAction editorSession={editor} breakpoint={breakpoint} {...props} showAnimation={false}/>
      }
    </>
  );
}

PaginationButtonWidget.moveableConfig = (editorSession, widget) => {
  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    cloneable: false,
    deletable: false,
    hideDefaultLines: true,
    onReparent: (widget, parent) => {
      return false
    }
  }
}

PaginationButtonWidget.processRequest = (widget) => {
  return widget;
}

export { PaginationButtonWidget };